module.exports = {
  "ids": {
    "color": {
      "accent": {
        "type": "color",
        "nob": [
          "system",
          "category",
          "concept"
        ],
        "value": "rgb(0, 84, 240)",
        "filePath": "./src/tokens/accent.json",
        "isSource": true,
        "original": {
          "type": "color",
          "nob": [
            "system",
            "category",
            "concept"
          ],
          "value": "{ids.color.blue.100.value}"
        },
        "name": "IDS_COLOR_ACCENT",
        "attributes": {
          "system": "ids",
          "category": "color",
          "concept": "accent",
          "hex": "0054f0",
          "rgb": {
            "r": 0,
            "g": 84,
            "b": 240,
            "a": 1
          },
          "hsl": {
            "h": 218.99999999999997,
            "s": 1,
            "l": 0.47058823529411764,
            "a": 1
          },
          "hsv": {
            "h": 218.99999999999997,
            "s": 1,
            "v": 0.9411764705882353,
            "a": 1
          }
        },
        "path": [
          "ids",
          "color",
          "accent"
        ]
      },
      "background": {
        "100": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(250, 249, 247)",
          "filePath": "./src/tokens/background.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.beige.100.value}"
          },
          "name": "IDS_COLOR_BACKGROUND_100",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "background",
            "scale": "100",
            "hex": "faf9f7",
            "rgb": {
              "r": 250,
              "g": 249,
              "b": 247,
              "a": 1
            },
            "hsl": {
              "h": 40,
              "s": 0.23076923076923025,
              "l": 0.9745098039215686,
              "a": 1
            },
            "hsv": {
              "h": 40,
              "s": 0.011999999999999959,
              "v": 0.9803921568627451,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "background",
            "100"
          ]
        },
        "200": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(246, 243, 240)",
          "filePath": "./src/tokens/background.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.beige.200.value}"
          },
          "name": "IDS_COLOR_BACKGROUND_200",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "background",
            "scale": "200",
            "hex": "f6f3f0",
            "rgb": {
              "r": 246,
              "g": 243,
              "b": 240,
              "a": 1
            },
            "hsl": {
              "h": 29.999999999999858,
              "s": 0.2500000000000006,
              "l": 0.9529411764705882,
              "a": 1
            },
            "hsv": {
              "h": 29.999999999999858,
              "s": 0.024390243902439053,
              "v": 0.9647058823529412,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "background",
            "200"
          ]
        },
        "300": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(241, 236, 232)",
          "filePath": "./src/tokens/background.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.beige.300.value}"
          },
          "name": "IDS_COLOR_BACKGROUND_300",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "background",
            "scale": "300",
            "hex": "f1ece8",
            "rgb": {
              "r": 241,
              "g": 236,
              "b": 232,
              "a": 1
            },
            "hsl": {
              "h": 26.66666666666677,
              "s": 0.2432432432432431,
              "l": 0.9274509803921569,
              "a": 1
            },
            "hsv": {
              "h": 26.66666666666677,
              "s": 0.03734439834024895,
              "v": 0.9450980392156862,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "background",
            "300"
          ]
        },
        "400": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(237, 230, 225)",
          "filePath": "./src/tokens/background.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.beige.400.value}"
          },
          "name": "IDS_COLOR_BACKGROUND_400",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "background",
            "scale": "400",
            "hex": "ede6e1",
            "rgb": {
              "r": 237,
              "g": 230,
              "b": 225,
              "a": 1
            },
            "hsl": {
              "h": 25.000000000000025,
              "s": 0.2500000000000003,
              "l": 0.9058823529411765,
              "a": 1
            },
            "hsv": {
              "h": 25.000000000000025,
              "s": 0.05063291139240512,
              "v": 0.9294117647058824,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "background",
            "400"
          ]
        },
        "500": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(232, 224, 217)",
          "filePath": "./src/tokens/background.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.beige.500.value}"
          },
          "name": "IDS_COLOR_BACKGROUND_500",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "background",
            "scale": "500",
            "hex": "e8e0d9",
            "rgb": {
              "r": 232,
              "g": 224,
              "b": 217,
              "a": 1
            },
            "hsl": {
              "h": 28.000000000000007,
              "s": 0.2459016393442622,
              "l": 0.8803921568627451,
              "a": 1
            },
            "hsv": {
              "h": 28.000000000000007,
              "s": 0.06465517241379312,
              "v": 0.9098039215686274,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "background",
            "500"
          ]
        }
      },
      "light-blue": {
        "100": {
          "name": "IDS_COLOR_LIGHT_BLUE_100",
          "color-name": "Gas Giant",
          "value": "rgb(151, 226, 247)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(151, 226, 247)",
          "hex": "#97e2f7",
          "internal-name": "CB 3",
          "pmsc": "PMS 291 C",
          "pmsu": "PMS 544 U",
          "cmykc": "35, 0, 2, 0",
          "cmyku": "34, 3, 0, 2",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Gas Giant",
            "color-name": "Gas Giant",
            "value": "rgb(151, 226, 247)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(151, 226, 247)",
            "hex": "#97e2f7",
            "internal-name": "CB 3",
            "pmsc": "PMS 291 C",
            "pmsu": "PMS 544 U",
            "cmykc": "35, 0, 2, 0",
            "cmyku": "34, 3, 0, 2"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "light-blue",
            "scale": "100",
            "hex": "97e2f7",
            "rgb": {
              "r": 151,
              "g": 226,
              "b": 247,
              "a": 1
            },
            "hsl": {
              "h": 193.125,
              "s": 0.8571428571428573,
              "l": 0.7803921568627451,
              "a": 1
            },
            "hsv": {
              "h": 193.125,
              "s": 0.38866396761133604,
              "v": 0.9686274509803922,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "light-blue",
            "100"
          ]
        },
        "200": {
          "name": "IDS_COLOR_LIGHT_BLUE_200",
          "color-name": "Blue Martini",
          "value": "rgb(76, 176, 211)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(76, 176, 211)",
          "hex": "#4cb0d3",
          "internal-name": "CB 2",
          "pmsc": "PMS 2389 C",
          "pmsu": "PMS 2389 U",
          "cmykc": "68, 13, 12, 0",
          "cmyku": "63, 16, 8, 0",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Blue Martini",
            "color-name": "Blue Martini",
            "value": "rgb(76, 176, 211)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(76, 176, 211)",
            "hex": "#4cb0d3",
            "internal-name": "CB 2",
            "pmsc": "PMS 2389 C",
            "pmsu": "PMS 2389 U",
            "cmykc": "68, 13, 12, 0",
            "cmyku": "63, 16, 8, 0"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "light-blue",
            "scale": "200",
            "hex": "4cb0d3",
            "rgb": {
              "r": 76,
              "g": 176,
              "b": 211,
              "a": 1
            },
            "hsl": {
              "h": 195.55555555555554,
              "s": 0.6053811659192824,
              "l": 0.5627450980392157,
              "a": 1
            },
            "hsv": {
              "h": 195.55555555555554,
              "s": 0.6398104265402843,
              "v": 0.8274509803921568,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "light-blue",
            "200"
          ]
        },
        "300": {
          "name": "IDS_COLOR_LIGHT_BLUE_300",
          "color-name": "Vanity",
          "value": "rgb(83, 146, 178)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(83, 146, 178)",
          "hex": "#5392b2",
          "internal-name": "CB 1",
          "pmsc": "PMS 2159 C",
          "pmsu": "PMS 2149 U",
          "cmykc": "70, 37, 18, 10",
          "cmyku": "65, 30, 15, 5",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Vanity",
            "color-name": "Vanity",
            "value": "rgb(83, 146, 178)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(83, 146, 178)",
            "hex": "#5392b2",
            "internal-name": "CB 1",
            "pmsc": "PMS 2159 C",
            "pmsu": "PMS 2149 U",
            "cmykc": "70, 37, 18, 10",
            "cmyku": "65, 30, 15, 5"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "light-blue",
            "scale": "300",
            "hex": "5392b2",
            "rgb": {
              "r": 83,
              "g": 146,
              "b": 178,
              "a": 1
            },
            "hsl": {
              "h": 200.2105263157895,
              "s": 0.3815261044176706,
              "l": 0.5117647058823529,
              "a": 1
            },
            "hsv": {
              "h": 200.2105263157895,
              "s": 0.5337078651685393,
              "v": 0.6980392156862745,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "light-blue",
            "300"
          ]
        }
      },
      "blue": {
        "100": {
          "name": "IDS_COLOR_BLUE_100",
          "color-name": "Megaman Helmet",
          "value": "rgb(0, 84, 240)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(0,84,240)",
          "hex": "#0054f0",
          "internal-name": "BL 1",
          "pms": "PMS 3005",
          "cmyk": "100,30,0,0",
          "ncs": "S 2565-R80B",
          "ral": "270 40 40 Zauberblau",
          "tcx": "18-4051 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Megaman Helmet",
            "color-name": "Megaman Helmet",
            "value": "rgb(0,84,240)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(0,84,240)",
            "hex": "#0054f0",
            "internal-name": "BL 1",
            "pms": "PMS 3005",
            "cmyk": "100,30,0,0",
            "ncs": "S 2565-R80B",
            "ral": "270 40 40 Zauberblau",
            "tcx": "18-4051 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "blue",
            "scale": "100",
            "hex": "0054f0",
            "rgb": {
              "r": 0,
              "g": 84,
              "b": 240,
              "a": 1
            },
            "hsl": {
              "h": 218.99999999999997,
              "s": 1,
              "l": 0.47058823529411764,
              "a": 1
            },
            "hsv": {
              "h": 218.99999999999997,
              "s": 1,
              "v": 0.9411764705882353,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "blue",
            "100"
          ]
        },
        "200": {
          "name": "IDS_COLOR_BLUE_200",
          "color-name": "Bracing Blue",
          "value": "rgb(0, 64, 128)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(0, 64, 128)",
          "hex": "#004080",
          "internal-name": "BL 1 Dark",
          "cmyk": "100,50,0,50",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Bracing Blue",
            "color-name": "Bracing Blue",
            "value": "rgb(0, 64, 128)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(0, 64, 128)",
            "hex": "#004080",
            "internal-name": "BL 1 Dark",
            "cmyk": "100,50,0,50"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "blue",
            "scale": "200",
            "hex": "004080",
            "rgb": {
              "r": 0,
              "g": 64,
              "b": 128,
              "a": 1
            },
            "hsl": {
              "h": 210,
              "s": 1,
              "l": 0.25098039215686274,
              "a": 1
            },
            "hsv": {
              "h": 210,
              "s": 1,
              "v": 0.5019607843137255,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "blue",
            "200"
          ]
        }
      },
      "orange": {
        "100": {
          "name": "IDS_COLOR_ORANGE_100",
          "color-name": "Wiener Schnitzel",
          "value": "rgb(240, 156, 0)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(240, 156, 0)",
          "hex": "#f09c00",
          "internal-name": "BL 1 Complement, Deprecated",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Wiener Schnitzel",
            "color-name": "Wiener Schnitzel",
            "value": "rgb(240, 156, 0)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(240, 156, 0)",
            "hex": "#f09c00",
            "internal-name": "BL 1 Complement, Deprecated"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "orange",
            "scale": "100",
            "hex": "f09c00",
            "rgb": {
              "r": 240,
              "g": 156,
              "b": 0,
              "a": 1
            },
            "hsl": {
              "h": 39,
              "s": 1,
              "l": 0.47058823529411764,
              "a": 1
            },
            "hsv": {
              "h": 39,
              "s": 1,
              "v": 0.9411764705882353,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "orange",
            "100"
          ]
        }
      },
      "beige": {
        "100": {
          "name": "IDS_COLOR_BEIGE_100",
          "color-name": "Doctor",
          "value": "rgb(250, 249, 247)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(250,249,247)",
          "hex": "#faf9f7",
          "internal-name": "BE 5",
          "pms": "PMS 9223 / 20%",
          "cmykc": "5, 10, 15, 3 / 20%",
          "cmyku": "3, 8, 14, 2 / 20%",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Doctor",
            "color-name": "Doctor",
            "value": "rgb(250,249,247)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(250,249,247)",
            "hex": "#faf9f7",
            "internal-name": "BE 5",
            "pms": "PMS 9223 / 20%",
            "cmykc": "5, 10, 15, 3 / 20%",
            "cmyku": "3, 8, 14, 2 / 20%"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "beige",
            "scale": "100",
            "hex": "faf9f7",
            "rgb": {
              "r": 250,
              "g": 249,
              "b": 247,
              "a": 1
            },
            "hsl": {
              "h": 40,
              "s": 0.23076923076923025,
              "l": 0.9745098039215686,
              "a": 1
            },
            "hsv": {
              "h": 40,
              "s": 0.011999999999999959,
              "v": 0.9803921568627451,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "beige",
            "100"
          ]
        },
        "200": {
          "name": "IDS_COLOR_BEIGE_200",
          "color-name": "The Speed Of Light",
          "value": "rgb(246, 243, 240)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(246,243,240)",
          "hex": "#f6f3f0",
          "internal-name": "BE 4",
          "pms": "PMS 9223 / 40%",
          "cmykc": "5, 10, 15, 3 / 40%",
          "cmyku": "3, 8, 14, 2 / 40%",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "The Speed Of Light",
            "color-name": "The Speed Of Light",
            "value": "rgb(246,243,240)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(246,243,240)",
            "hex": "#f6f3f0",
            "internal-name": "BE 4",
            "pms": "PMS 9223 / 40%",
            "cmykc": "5, 10, 15, 3 / 40%",
            "cmyku": "3, 8, 14, 2 / 40%"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "beige",
            "scale": "200",
            "hex": "f6f3f0",
            "rgb": {
              "r": 246,
              "g": 243,
              "b": 240,
              "a": 1
            },
            "hsl": {
              "h": 29.999999999999858,
              "s": 0.2500000000000006,
              "l": 0.9529411764705882,
              "a": 1
            },
            "hsv": {
              "h": 29.999999999999858,
              "s": 0.024390243902439053,
              "v": 0.9647058823529412,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "beige",
            "200"
          ]
        },
        "300": {
          "name": "IDS_COLOR_BEIGE_300",
          "color-name": "Valhallan Blizzard",
          "value": "rgb(241, 236, 232)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(241,236,232)",
          "hex": "#f1ece8",
          "internal-name": "BE 3",
          "pms": "PMS 9223 / 60%",
          "cmykc": "5, 10, 15, 3 / 60%",
          "cmyku": "3, 8, 14, 2 / 60%",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Valhallan Blizzard",
            "color-name": "Valhallan Blizzard",
            "value": "rgb(241,236,232)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(241,236,232)",
            "hex": "#f1ece8",
            "internal-name": "BE 3",
            "pms": "PMS 9223 / 60%",
            "cmykc": "5, 10, 15, 3 / 60%",
            "cmyku": "3, 8, 14, 2 / 60%"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "beige",
            "scale": "300",
            "hex": "f1ece8",
            "rgb": {
              "r": 241,
              "g": 236,
              "b": 232,
              "a": 1
            },
            "hsl": {
              "h": 26.66666666666677,
              "s": 0.2432432432432431,
              "l": 0.9274509803921569,
              "a": 1
            },
            "hsv": {
              "h": 26.66666666666677,
              "s": 0.03734439834024895,
              "v": 0.9450980392156862,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "beige",
            "300"
          ]
        },
        "400": {
          "name": "IDS_COLOR_BEIGE_400",
          "color-name": "Desert Storm",
          "value": "rgb(237, 230, 225)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(237,230,225)",
          "hex": "#ede6e1",
          "internal-name": "BE 2",
          "pmsc": "PMS 9223 / 80%",
          "cmykc": "5, 10, 15, 3 / 80%",
          "cmyku": "3, 8, 14, 2 / 80%",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Desert Storm",
            "color-name": "Desert Storm",
            "value": "rgb(237,230,225)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(237,230,225)",
            "hex": "#ede6e1",
            "internal-name": "BE 2",
            "pmsc": "PMS 9223 / 80%",
            "cmykc": "5, 10, 15, 3 / 80%",
            "cmyku": "3, 8, 14, 2 / 80%"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "beige",
            "scale": "400",
            "hex": "ede6e1",
            "rgb": {
              "r": 237,
              "g": 230,
              "b": 225,
              "a": 1
            },
            "hsl": {
              "h": 25.000000000000025,
              "s": 0.2500000000000003,
              "l": 0.9058823529411765,
              "a": 1
            },
            "hsv": {
              "h": 25.000000000000025,
              "s": 0.05063291139240512,
              "v": 0.9294117647058824,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "beige",
            "400"
          ]
        },
        "500": {
          "name": "IDS_COLOR_BEIGE_500",
          "color-name": "Stone Harbour",
          "value": "rgb(232, 224, 217)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(232,224,217)",
          "hex": "#e8e0d9",
          "internal-name": "BE 1",
          "pms": "PMS 9223",
          "cmykc": "5, 10, 15, 3",
          "cmyku": "3, 8, 14, 2",
          "ncs": "1005-Y60R",
          "ral": "060 85 05 Champagnerosé",
          "tcx": "12-0000 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Stone Harbour",
            "color-name": "Stone Harbour",
            "value": "rgb(232,224,217)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(232,224,217)",
            "hex": "#e8e0d9",
            "internal-name": "BE 1",
            "pms": "PMS 9223",
            "cmykc": "5, 10, 15, 3",
            "cmyku": "3, 8, 14, 2",
            "ncs": "1005-Y60R",
            "ral": "060 85 05 Champagnerosé",
            "tcx": "12-0000 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "beige",
            "scale": "500",
            "hex": "e8e0d9",
            "rgb": {
              "r": 232,
              "g": 224,
              "b": 217,
              "a": 1
            },
            "hsl": {
              "h": 28.000000000000007,
              "s": 0.2459016393442622,
              "l": 0.8803921568627451,
              "a": 1
            },
            "hsv": {
              "h": 28.000000000000007,
              "s": 0.06465517241379312,
              "v": 0.9098039215686274,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "beige",
            "500"
          ]
        }
      },
      "pink": {
        "100": {
          "name": "IDS_COLOR_PINK_100",
          "color-name": "Peach Crayon",
          "value": "rgb(255, 201, 166)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(255, 201, 166)",
          "hex": "#ffc9a6",
          "internal-name": "CR 3",
          "pmsc": "PMS 7520 C",
          "pmsu": "PMS 7520 U",
          "cmykc": "0, 20, 25, 5",
          "cmyku": "5, 17, 31, 0",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Peach Crayon",
            "color-name": "Peach Crayon",
            "value": "rgb(255, 201, 166)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(255, 201, 166)",
            "hex": "#ffc9a6",
            "internal-name": "CR 3",
            "pmsc": "PMS 7520 C",
            "pmsu": "PMS 7520 U",
            "cmykc": "0, 20, 25, 5",
            "cmyku": "5, 17, 31, 0"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "pink",
            "scale": "100",
            "hex": "ffc9a6",
            "rgb": {
              "r": 255,
              "g": 201,
              "b": 166,
              "a": 1
            },
            "hsl": {
              "h": 23.59550561797752,
              "s": 1,
              "l": 0.8254901960784313,
              "a": 1
            },
            "hsv": {
              "h": 23.59550561797752,
              "s": 0.34901960784313724,
              "v": 1,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "pink",
            "100"
          ]
        },
        "200": {
          "name": "IDS_COLOR_PINK_200",
          "color-name": "Fresh Salmon",
          "value": "rgb(255, 133, 105)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(255, 133, 105)",
          "hex": "#ff8569",
          "internal-name": "CR 2",
          "pmsc": "PMS 486 C",
          "pmsu": "PMS 487 U",
          "cmykc": "0, 53, 48, 0",
          "cmyku": "0, 47, 46, 0",
          "ncs": "S 1050-Y80R",
          "ral": "030 70 40 Flamingorot",
          "tcx": "16-1526 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Fresh Salmon",
            "color-name": "Fresh Salmon",
            "value": "rgb(255, 133, 105)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(255, 133, 105)",
            "hex": "#ff8569",
            "internal-name": "CR 2",
            "pmsc": "PMS 486 C",
            "pmsu": "PMS 487 U",
            "cmykc": "0, 53, 48, 0",
            "cmyku": "0, 47, 46, 0",
            "ncs": "S 1050-Y80R",
            "ral": "030 70 40 Flamingorot",
            "tcx": "16-1526 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "pink",
            "scale": "200",
            "hex": "ff8569",
            "rgb": {
              "r": 255,
              "g": 133,
              "b": 105,
              "a": 1
            },
            "hsl": {
              "h": 11.200000000000006,
              "s": 1,
              "l": 0.7058823529411764,
              "a": 1
            },
            "hsv": {
              "h": 11.200000000000006,
              "s": 0.5882352941176471,
              "v": 1,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "pink",
            "200"
          ]
        },
        "300": {
          "name": "IDS_COLOR_PINK_300",
          "color-name": "Musk Deer",
          "value": "rgb(128, 92, 92)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(128, 92, 92)",
          "hex": "#805c5c",
          "internal-name": "CR 1",
          "pmsc": "PMS 7639 C",
          "pmsu": "PMS 4995 U",
          "cmykc": "41, 62, 48, 7",
          "cmyku": "0, 42, 15, 48",
          "ncs": "S 5020-R10B",
          "ral": "360 40 15 Rubingrau",
          "tcx": "18-1612 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Musk Deer",
            "color-name": "Musk Deer",
            "value": "rgb(128, 92, 92)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(128, 92, 92)",
            "hex": "#805c5c",
            "internal-name": "CR 1",
            "pmsc": "PMS 7639 C",
            "pmsu": "PMS 4995 U",
            "cmykc": "41, 62, 48, 7",
            "cmyku": "0, 42, 15, 48",
            "ncs": "S 5020-R10B",
            "ral": "360 40 15 Rubingrau",
            "tcx": "18-1612 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "pink",
            "scale": "300",
            "hex": "805c5c",
            "rgb": {
              "r": 128,
              "g": 92,
              "b": 92,
              "a": 1
            },
            "hsl": {
              "h": 0,
              "s": 0.16363636363636364,
              "l": 0.43137254901960786,
              "a": 1
            },
            "hsv": {
              "h": 0,
              "s": 0.28125,
              "v": 0.5019607843137255,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "pink",
            "300"
          ]
        }
      },
      "green": {
        "100": {
          "name": "IDS_COLOR_GREEN_100",
          "color-name": "Camarone",
          "value": "rgb(33, 115, 49)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(33, 115, 49)",
          "hex": "#217331",
          "internal-name": "green",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Camarone",
            "color-name": "Camarone",
            "value": "rgb(33, 115, 49)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(33, 115, 49)",
            "hex": "#217331",
            "internal-name": "green"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "green",
            "scale": "100",
            "hex": "217331",
            "rgb": {
              "r": 33,
              "g": 115,
              "b": 49,
              "a": 1
            },
            "hsl": {
              "h": 131.70731707317074,
              "s": 0.554054054054054,
              "l": 0.2901960784313726,
              "a": 1
            },
            "hsv": {
              "h": 131.70731707317074,
              "s": 0.7130434782608694,
              "v": 0.45098039215686275,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "green",
            "100"
          ]
        }
      },
      "red": {
        "100": {
          "name": "IDS_COLOR_RED_100",
          "color-name": "Virtual Boy",
          "value": "rgb(187, 50, 12)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(187, 50, 12)",
          "hex": "#bb320c",
          "internal-name": "red",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Virtual Boy",
            "color-name": "Virtual Boy",
            "value": "rgb(187, 50, 12)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(187, 50, 12)",
            "hex": "#bb320c",
            "internal-name": "red"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "red",
            "scale": "100",
            "hex": "bb320c",
            "rgb": {
              "r": 187,
              "g": 50,
              "b": 12,
              "a": 1
            },
            "hsl": {
              "h": 13.028571428571428,
              "s": 0.8793969849246233,
              "l": 0.3901960784313725,
              "a": 1
            },
            "hsv": {
              "h": 13.028571428571428,
              "s": 0.9358288770053477,
              "v": 0.7333333333333333,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "red",
            "100"
          ]
        }
      },
      "brown": {
        "100": {
          "name": "IDS_COLOR_BROWN_100",
          "color-name": "Fozzie Bear",
          "value": "rgb(110, 98, 94)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(110,98,94)",
          "hex": "#6e625e",
          "internal-name": "LB 1",
          "pms": "PMS 7531",
          "cmykc": "15, 27, 36, 51",
          "cmyku": "14, 23, 33, 46",
          "ncs": "6010-Y30R",
          "ral": "060 50 10 Sandsteingrau",
          "tcx": "18-1017 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Fozzie Bear",
            "color-name": "Fozzie Bear",
            "value": "rgb(110,98,94)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(110,98,94)",
            "hex": "#6e625e",
            "internal-name": "LB 1",
            "pms": "PMS 7531",
            "cmykc": "15, 27, 36, 51",
            "cmyku": "14, 23, 33, 46",
            "ncs": "6010-Y30R",
            "ral": "060 50 10 Sandsteingrau",
            "tcx": "18-1017 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "brown",
            "scale": "100",
            "hex": "6e625e",
            "rgb": {
              "r": 110,
              "g": 98,
              "b": 94,
              "a": 1
            },
            "hsl": {
              "h": 15,
              "s": 0.0784313725490196,
              "l": 0.4,
              "a": 1
            },
            "hsv": {
              "h": 15,
              "s": 0.14545454545454545,
              "v": 0.43137254901960786,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "brown",
            "100"
          ]
        },
        "200": {
          "name": "IDS_COLOR_BROWN_200",
          "color-name": "Black Slug",
          "value": "rgb(51, 30, 17)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(51,30,17)",
          "hex": "#331e11",
          "internal-name": "BR 1",
          "pms": "PMS 2322",
          "cmykc": "32, 72, 99, 81",
          "cmyku": "25, 70, 70, 80",
          "ncs": "S 8010-Y50R",
          "ral": "050 30 10 Obsidianbraun",
          "tcx": "19-0814 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Black Slug",
            "color-name": "Black Slug",
            "value": "rgb(51,30,17)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(51,30,17)",
            "hex": "#331e11",
            "internal-name": "BR 1",
            "pms": "PMS 2322",
            "cmykc": "32, 72, 99, 81",
            "cmyku": "25, 70, 70, 80",
            "ncs": "S 8010-Y50R",
            "ral": "050 30 10 Obsidianbraun",
            "tcx": "19-0814 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "brown",
            "scale": "200",
            "hex": "331e11",
            "rgb": {
              "r": 51,
              "g": 30,
              "b": 17,
              "a": 1
            },
            "hsl": {
              "h": 22.94117647058823,
              "s": 0.5000000000000001,
              "l": 0.13333333333333333,
              "a": 1
            },
            "hsv": {
              "h": 22.94117647058823,
              "s": 0.6666666666666667,
              "v": 0.2,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "brown",
            "200"
          ]
        }
      },
      "teal": {
        "100": {
          "name": "IDS_COLOR_TEAL_100",
          "color-name": "Spearmint Water",
          "value": "rgb(181, 237, 232)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(181, 237, 232)",
          "hex": "#b5ede8",
          "internal-name": "CG 3",
          "pmsc": "PMS 7457 C",
          "pmsu": "PMS 5523 U",
          "cmykc": "25, 0, 13, 0",
          "cmyku": "20, 0, 12, 0",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Spearmint Water",
            "color-name": "Spearmint Water",
            "value": "rgb(181, 237, 232)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(181, 237, 232)",
            "hex": "#b5ede8",
            "internal-name": "CG 3",
            "pmsc": "PMS 7457 C",
            "pmsu": "PMS 5523 U",
            "cmykc": "25, 0, 13, 0",
            "cmyku": "20, 0, 12, 0"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "teal",
            "scale": "100",
            "hex": "b5ede8",
            "rgb": {
              "r": 181,
              "g": 237,
              "b": 232,
              "a": 1
            },
            "hsl": {
              "h": 174.64285714285714,
              "s": 0.6086956521739131,
              "l": 0.8196078431372549,
              "a": 1
            },
            "hsv": {
              "h": 174.64285714285714,
              "s": 0.23628691983122363,
              "v": 0.9294117647058824,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "teal",
            "100"
          ]
        },
        "200": {
          "name": "IDS_COLOR_TEAL_200",
          "color-name": "Tranquil Teal",
          "value": "rgb(135, 199, 186)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(135, 199, 186)",
          "hex": "#87c7ba",
          "internal-name": "CG 2",
          "pmsc": "PMS 564 C",
          "pmsu": "PMS 565 U",
          "cmykc": "53, 0, 32, 0",
          "cmyku": "42, 0, 27, 0",
          "ncs": "S 1030-B50G",
          "ral": "18 80 20 Opalturkis",
          "tcx": "14-5711 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Tranquil Teal",
            "color-name": "Tranquil Teal",
            "value": "rgb(135, 199, 186)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(135, 199, 186)",
            "hex": "#87c7ba",
            "internal-name": "CG 2",
            "pmsc": "PMS 564 C",
            "pmsu": "PMS 565 U",
            "cmykc": "53, 0, 32, 0",
            "cmyku": "42, 0, 27, 0",
            "ncs": "S 1030-B50G",
            "ral": "18 80 20 Opalturkis",
            "tcx": "14-5711 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "teal",
            "scale": "200",
            "hex": "87c7ba",
            "rgb": {
              "r": 135,
              "g": 199,
              "b": 186,
              "a": 1
            },
            "hsl": {
              "h": 167.8125,
              "s": 0.3636363636363636,
              "l": 0.6549019607843137,
              "a": 1
            },
            "hsv": {
              "h": 167.8125,
              "s": 0.32160804020100503,
              "v": 0.7803921568627451,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "teal",
            "200"
          ]
        },
        "300": {
          "name": "IDS_COLOR_TEAL_300",
          "color-name": "Little League",
          "value": "rgb(107, 153, 148)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(107, 153, 148)",
          "hex": "#6b9994",
          "internal-name": "CG 1",
          "pmsc": "PMS 2211 C",
          "pmsu": "PMS 5493 U",
          "cmykc": "63, 25, 35, 5",
          "cmyku": "47, 6, 20, 20",
          "ncs": "S 4020-B30G",
          "ral": "200 60 15 Waidindigo",
          "tcx": "17-5110 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Little League",
            "color-name": "Little League",
            "value": "rgb(107, 153, 148)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(107, 153, 148)",
            "hex": "#6b9994",
            "internal-name": "CG 1",
            "pmsc": "PMS 2211 C",
            "pmsu": "PMS 5493 U",
            "cmykc": "63, 25, 35, 5",
            "cmyku": "47, 6, 20, 20",
            "ncs": "S 4020-B30G",
            "ral": "200 60 15 Waidindigo",
            "tcx": "17-5110 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "teal",
            "scale": "300",
            "hex": "6b9994",
            "rgb": {
              "r": 107,
              "g": 153,
              "b": 148,
              "a": 1
            },
            "hsl": {
              "h": 173.47826086956525,
              "s": 0.184,
              "l": 0.5098039215686274,
              "a": 1
            },
            "hsv": {
              "h": 173.47826086956525,
              "s": 0.3006535947712418,
              "v": 0.6,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "teal",
            "300"
          ]
        }
      },
      "yellow": {
        "100": {
          "name": "IDS_COLOR_YELLOW_100",
          "color-name": "Swedish Yellow",
          "value": "rgb(255, 224, 130)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(255, 224, 130)",
          "hex": "#ffe082",
          "internal-name": "CY 3",
          "pmsc": "PMS 7402 C",
          "pmsu": "PMS 2001 U",
          "cmykc": "0, 6, 53, 0",
          "cmyku": "0, 3, 48, 0",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Swedish Yellow",
            "color-name": "Swedish Yellow",
            "value": "rgb(255, 224, 130)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(255, 224, 130)",
            "hex": "#ffe082",
            "internal-name": "CY 3",
            "pmsc": "PMS 7402 C",
            "pmsu": "PMS 2001 U",
            "cmykc": "0, 6, 53, 0",
            "cmyku": "0, 3, 48, 0"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "yellow",
            "scale": "100",
            "hex": "ffe082",
            "rgb": {
              "r": 255,
              "g": 224,
              "b": 130,
              "a": 1
            },
            "hsl": {
              "h": 45.12,
              "s": 1,
              "l": 0.7549019607843137,
              "a": 1
            },
            "hsv": {
              "h": 45.12,
              "s": 0.4901960784313726,
              "v": 1,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "yellow",
            "100"
          ]
        },
        "200": {
          "name": "IDS_COLOR_YELLOW_200",
          "color-name": "Go Bananas",
          "value": "rgb(252, 199, 79)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(252, 199, 79)",
          "hex": "#fcc74f",
          "internal-name": "CY 2",
          "pmsc": "PMS 141 C",
          "pmsu": "PMS 7403 U",
          "cmykc": "0, 20, 72, 0",
          "cmyku": "0, 14, 65, 0",
          "ncs": "S 1050-Y10R",
          "ral": "080 80 60 Vollgelb",
          "tcx": "14-0846 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Go Bananas",
            "color-name": "Go Bananas",
            "value": "rgb(252, 199, 79)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(252, 199, 79)",
            "hex": "#fcc74f",
            "internal-name": "CY 2",
            "pmsc": "PMS 141 C",
            "pmsu": "PMS 7403 U",
            "cmykc": "0, 20, 72, 0",
            "cmyku": "0, 14, 65, 0",
            "ncs": "S 1050-Y10R",
            "ral": "080 80 60 Vollgelb",
            "tcx": "14-0846 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "yellow",
            "scale": "200",
            "hex": "fcc74f",
            "rgb": {
              "r": 252,
              "g": 199,
              "b": 79,
              "a": 1
            },
            "hsl": {
              "h": 41.61849710982659,
              "s": 0.9664804469273744,
              "l": 0.6490196078431373,
              "a": 1
            },
            "hsv": {
              "h": 41.61849710982659,
              "s": 0.6865079365079365,
              "v": 0.9882352941176471,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "yellow",
            "200"
          ]
        },
        "300": {
          "name": "IDS_COLOR_YELLOW_300",
          "color-name": "Apple Cinnamon",
          "value": "rgb(176, 135, 89)",
          "nob": [
            "system",
            "category",
            "variant",
            "scale"
          ],
          "rgb": "rgb(176, 135, 89)",
          "hex": "#b08759",
          "internal-name": "CY 1",
          "pmsc": "PMS 2317 C",
          "pmsu": "PMS 2313 U",
          "cmykc": "35, 48, 70, 5",
          "cmyku": "0, 30, 54, 27",
          "ncs": "S 4030-Y30R",
          "ral": "060 50 30 Senfbraun",
          "tcx": "17-1125 TCX",
          "filePath": "./src/tokens/base.json",
          "isSource": true,
          "original": {
            "name": "Apple Cinnamon",
            "color-name": "Apple Cinnamon",
            "value": "rgb(176, 135, 89)",
            "nob": [
              "system",
              "category",
              "variant",
              "scale"
            ],
            "rgb": "rgb(176, 135, 89)",
            "hex": "#b08759",
            "internal-name": "CY 1",
            "pmsc": "PMS 2317 C",
            "pmsu": "PMS 2313 U",
            "cmykc": "35, 48, 70, 5",
            "cmyku": "0, 30, 54, 27",
            "ncs": "S 4030-Y30R",
            "ral": "060 50 30 Senfbraun",
            "tcx": "17-1125 TCX"
          },
          "attributes": {
            "system": "ids",
            "category": "color",
            "variant": "yellow",
            "scale": "300",
            "hex": "b08759",
            "rgb": {
              "r": 176,
              "g": 135,
              "b": 89,
              "a": 1
            },
            "hsl": {
              "h": 31.724137931034484,
              "s": 0.3551020408163265,
              "l": 0.5196078431372548,
              "a": 1
            },
            "hsv": {
              "h": 31.724137931034484,
              "s": 0.4943181818181818,
              "v": 0.6901960784313725,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "yellow",
            "300"
          ]
        }
      },
      "white": {
        "name": "IDS_COLOR_WHITE",
        "color-name": "White",
        "value": "rgb(255, 255, 255)",
        "nob": [
          "system",
          "category",
          "variant"
        ],
        "rgb": "rgb(255, 255, 255)",
        "hex": "#FFFFFF",
        "internal-name": "CW",
        "filePath": "./src/tokens/base.json",
        "isSource": true,
        "original": {
          "name": "White",
          "color-name": "White",
          "value": "rgb(255, 255, 255)",
          "nob": [
            "system",
            "category",
            "variant"
          ],
          "rgb": "rgb(255, 255, 255)",
          "hex": "#FFFFFF",
          "internal-name": "CW"
        },
        "attributes": {
          "system": "ids",
          "category": "color",
          "variant": "white",
          "hex": "ffffff",
          "rgb": {
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "hsl": {
            "h": 0,
            "s": 0,
            "l": 1,
            "a": 1
          },
          "hsv": {
            "h": 0,
            "s": 0,
            "v": 1,
            "a": 1
          }
        },
        "path": [
          "ids",
          "color",
          "white"
        ]
      },
      "cta": {
        "nob": [
          "system",
          "category",
          "concept"
        ],
        "value": "rgb(0, 84, 240)",
        "filePath": "./src/tokens/cta.json",
        "isSource": true,
        "original": {
          "nob": [
            "system",
            "category",
            "concept"
          ],
          "value": "{ids.color.accent.value}"
        },
        "name": "IDS_COLOR_CTA",
        "attributes": {
          "system": "ids",
          "category": "color",
          "concept": "cta",
          "hex": "0054f0",
          "rgb": {
            "r": 0,
            "g": 84,
            "b": 240,
            "a": 1
          },
          "hsl": {
            "h": 218.99999999999997,
            "s": 1,
            "l": 0.47058823529411764,
            "a": 1
          },
          "hsv": {
            "h": 218.99999999999997,
            "s": 1,
            "v": 0.9411764705882353,
            "a": 1
          }
        },
        "path": [
          "ids",
          "color",
          "cta"
        ]
      },
      "infographic": {
        "100": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(255, 201, 166)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.pink.100.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_100",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "100",
            "hex": "ffc9a6",
            "rgb": {
              "r": 255,
              "g": 201,
              "b": 166,
              "a": 1
            },
            "hsl": {
              "h": 23.59550561797752,
              "s": 1,
              "l": 0.8254901960784313,
              "a": 1
            },
            "hsv": {
              "h": 23.59550561797752,
              "s": 0.34901960784313724,
              "v": 1,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "100"
          ]
        },
        "200": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(255, 133, 105)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.pink.200.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_200",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "200",
            "hex": "ff8569",
            "rgb": {
              "r": 255,
              "g": 133,
              "b": 105,
              "a": 1
            },
            "hsl": {
              "h": 11.200000000000006,
              "s": 1,
              "l": 0.7058823529411764,
              "a": 1
            },
            "hsv": {
              "h": 11.200000000000006,
              "s": 0.5882352941176471,
              "v": 1,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "200"
          ]
        },
        "300": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(128, 92, 92)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.pink.300.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_300",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "300",
            "hex": "805c5c",
            "rgb": {
              "r": 128,
              "g": 92,
              "b": 92,
              "a": 1
            },
            "hsl": {
              "h": 0,
              "s": 0.16363636363636364,
              "l": 0.43137254901960786,
              "a": 1
            },
            "hsv": {
              "h": 0,
              "s": 0.28125,
              "v": 0.5019607843137255,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "300"
          ]
        },
        "400": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(255, 224, 130)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.yellow.100.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_400",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "400",
            "hex": "ffe082",
            "rgb": {
              "r": 255,
              "g": 224,
              "b": 130,
              "a": 1
            },
            "hsl": {
              "h": 45.12,
              "s": 1,
              "l": 0.7549019607843137,
              "a": 1
            },
            "hsv": {
              "h": 45.12,
              "s": 0.4901960784313726,
              "v": 1,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "400"
          ]
        },
        "500": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(252, 199, 79)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.yellow.200.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_500",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "500",
            "hex": "fcc74f",
            "rgb": {
              "r": 252,
              "g": 199,
              "b": 79,
              "a": 1
            },
            "hsl": {
              "h": 41.61849710982659,
              "s": 0.9664804469273744,
              "l": 0.6490196078431373,
              "a": 1
            },
            "hsv": {
              "h": 41.61849710982659,
              "s": 0.6865079365079365,
              "v": 0.9882352941176471,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "500"
          ]
        },
        "600": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(176, 135, 89)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.yellow.300.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_600",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "600",
            "hex": "b08759",
            "rgb": {
              "r": 176,
              "g": 135,
              "b": 89,
              "a": 1
            },
            "hsl": {
              "h": 31.724137931034484,
              "s": 0.3551020408163265,
              "l": 0.5196078431372548,
              "a": 1
            },
            "hsv": {
              "h": 31.724137931034484,
              "s": 0.4943181818181818,
              "v": 0.6901960784313725,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "600"
          ]
        },
        "700": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(181, 237, 232)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.teal.100.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_700",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "700",
            "hex": "b5ede8",
            "rgb": {
              "r": 181,
              "g": 237,
              "b": 232,
              "a": 1
            },
            "hsl": {
              "h": 174.64285714285714,
              "s": 0.6086956521739131,
              "l": 0.8196078431372549,
              "a": 1
            },
            "hsv": {
              "h": 174.64285714285714,
              "s": 0.23628691983122363,
              "v": 0.9294117647058824,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "700"
          ]
        },
        "800": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(135, 199, 186)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.teal.200.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_800",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "800",
            "hex": "87c7ba",
            "rgb": {
              "r": 135,
              "g": 199,
              "b": 186,
              "a": 1
            },
            "hsl": {
              "h": 167.8125,
              "s": 0.3636363636363636,
              "l": 0.6549019607843137,
              "a": 1
            },
            "hsv": {
              "h": 167.8125,
              "s": 0.32160804020100503,
              "v": 0.7803921568627451,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "800"
          ]
        },
        "900": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(107, 153, 148)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.teal.300.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_900",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "900",
            "hex": "6b9994",
            "rgb": {
              "r": 107,
              "g": 153,
              "b": 148,
              "a": 1
            },
            "hsl": {
              "h": 173.47826086956525,
              "s": 0.184,
              "l": 0.5098039215686274,
              "a": 1
            },
            "hsv": {
              "h": 173.47826086956525,
              "s": 0.3006535947712418,
              "v": 0.6,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "900"
          ]
        },
        "1000": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(151, 226, 247)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.light-blue.100.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_1000",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "1000",
            "hex": "97e2f7",
            "rgb": {
              "r": 151,
              "g": 226,
              "b": 247,
              "a": 1
            },
            "hsl": {
              "h": 193.125,
              "s": 0.8571428571428573,
              "l": 0.7803921568627451,
              "a": 1
            },
            "hsv": {
              "h": 193.125,
              "s": 0.38866396761133604,
              "v": 0.9686274509803922,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "1000"
          ]
        },
        "1100": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(76, 176, 211)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.light-blue.200.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_1100",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "1100",
            "hex": "4cb0d3",
            "rgb": {
              "r": 76,
              "g": 176,
              "b": 211,
              "a": 1
            },
            "hsl": {
              "h": 195.55555555555554,
              "s": 0.6053811659192824,
              "l": 0.5627450980392157,
              "a": 1
            },
            "hsv": {
              "h": 195.55555555555554,
              "s": 0.6398104265402843,
              "v": 0.8274509803921568,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "1100"
          ]
        },
        "1200": {
          "nob": [
            "system",
            "category",
            "concept",
            "scale"
          ],
          "value": "rgb(83, 146, 178)",
          "filePath": "./src/tokens/infographic.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "scale"
            ],
            "value": "{ids.color.light-blue.300.value}"
          },
          "name": "IDS_COLOR_INFOGRAPHIC_1200",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "infographic",
            "scale": "1200",
            "hex": "5392b2",
            "rgb": {
              "r": 83,
              "g": 146,
              "b": 178,
              "a": 1
            },
            "hsl": {
              "h": 200.2105263157895,
              "s": 0.3815261044176706,
              "l": 0.5117647058823529,
              "a": 1
            },
            "hsv": {
              "h": 200.2105263157895,
              "s": 0.5337078651685393,
              "v": 0.6980392156862745,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "infographic",
            "1200"
          ]
        }
      },
      "shadow": {
        "light": {
          "nob": [
            "system",
            "category",
            "property",
            "mode"
          ],
          "value": "rgb(110, 98, 94)",
          "filePath": "./src/tokens/shadow.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "property",
              "mode"
            ],
            "value": "{ids.color.brown.100.value}"
          },
          "name": "IDS_COLOR_SHADOW_LIGHT",
          "attributes": {
            "system": "ids",
            "category": "color",
            "property": "shadow",
            "mode": "light",
            "hex": "6e625e",
            "rgb": {
              "r": 110,
              "g": 98,
              "b": 94,
              "a": 1
            },
            "hsl": {
              "h": 15,
              "s": 0.0784313725490196,
              "l": 0.4,
              "a": 1
            },
            "hsv": {
              "h": 15,
              "s": 0.14545454545454545,
              "v": 0.43137254901960786,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "shadow",
            "light"
          ]
        },
        "dark": {
          "nob": [
            "system",
            "category",
            "property",
            "mode"
          ],
          "value": "rgb(51, 30, 17)",
          "filePath": "./src/tokens/shadow.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "property",
              "mode"
            ],
            "value": "{ids.color.brown.200.value}"
          },
          "name": "IDS_COLOR_SHADOW_DARK",
          "attributes": {
            "system": "ids",
            "category": "color",
            "property": "shadow",
            "mode": "dark",
            "hex": "331e11",
            "rgb": {
              "r": 51,
              "g": 30,
              "b": 17,
              "a": 1
            },
            "hsl": {
              "h": 22.94117647058823,
              "s": 0.5000000000000001,
              "l": 0.13333333333333333,
              "a": 1
            },
            "hsv": {
              "h": 22.94117647058823,
              "s": 0.6666666666666667,
              "v": 0.2,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "shadow",
            "dark"
          ]
        }
      },
      "states": {
        "disabled": {
          "nob": [
            "system",
            "category",
            "concept",
            "variant"
          ],
          "modify": [
            {
              "type": "alpha",
              "amount": "0.3"
            }
          ],
          "value": "rgba(110,98,94,0.3)",
          "filePath": "./src/tokens/states.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant"
            ],
            "modify": [
              {
                "type": "alpha",
                "amount": "0.3"
              }
            ],
            "value": "{ids.color.brown.100.value}"
          },
          "name": "IDS_COLOR_STATES_DISABLED",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "states",
            "variant": "disabled",
            "hex": "6e625e",
            "rgb": {
              "r": 110,
              "g": 98,
              "b": 94,
              "a": 1
            },
            "hsl": {
              "h": 15,
              "s": 0.0784313725490196,
              "l": 0.4,
              "a": 1
            },
            "hsv": {
              "h": 15,
              "s": 0.14545454545454545,
              "v": 0.43137254901960786,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "states",
            "disabled"
          ]
        },
        "active": {
          "nob": [
            "system",
            "category",
            "concept",
            "variant"
          ],
          "value": "rgb(0, 64, 128)",
          "filePath": "./src/tokens/states.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant"
            ],
            "value": "{ids.color.blue.200.value}"
          },
          "name": "IDS_COLOR_STATES_ACTIVE",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "states",
            "variant": "active",
            "hex": "004080",
            "rgb": {
              "r": 0,
              "g": 64,
              "b": 128,
              "a": 1
            },
            "hsl": {
              "h": 210,
              "s": 1,
              "l": 0.25098039215686274,
              "a": 1
            },
            "hsv": {
              "h": 210,
              "s": 1,
              "v": 0.5019607843137255,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "states",
            "active"
          ]
        },
        "hover": {
          "nob": [
            "system",
            "category",
            "concept",
            "variant"
          ],
          "value": "rgb(0, 64, 128)",
          "filePath": "./src/tokens/states.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant"
            ],
            "value": "{ids.color.blue.200.value}"
          },
          "name": "IDS_COLOR_STATES_HOVER",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "states",
            "variant": "hover",
            "hex": "004080",
            "rgb": {
              "r": 0,
              "g": 64,
              "b": 128,
              "a": 1
            },
            "hsl": {
              "h": 210,
              "s": 1,
              "l": 0.25098039215686274,
              "a": 1
            },
            "hsv": {
              "h": 210,
              "s": 1,
              "v": 0.5019607843137255,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "states",
            "hover"
          ]
        },
        "focus": {
          "nob": [
            "system",
            "category",
            "concept",
            "variant"
          ],
          "value": "rgb(0, 84, 240)",
          "filePath": "./src/tokens/states.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant"
            ],
            "value": "{ids.color.blue.100.value}"
          },
          "name": "IDS_COLOR_STATES_FOCUS",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "states",
            "variant": "focus",
            "hex": "0054f0",
            "rgb": {
              "r": 0,
              "g": 84,
              "b": 240,
              "a": 1
            },
            "hsl": {
              "h": 218.99999999999997,
              "s": 1,
              "l": 0.47058823529411764,
              "a": 1
            },
            "hsv": {
              "h": 218.99999999999997,
              "s": 1,
              "v": 0.9411764705882353,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "states",
            "focus"
          ]
        }
      },
      "status": {
        "error": {
          "nob": [
            "system",
            "category",
            "concept",
            "variant"
          ],
          "value": "rgb(187, 50, 12)",
          "filePath": "./src/tokens/status.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant"
            ],
            "value": "{ids.color.red.100.value}"
          },
          "name": "IDS_COLOR_STATUS_ERROR",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "status",
            "variant": "error",
            "hex": "bb320c",
            "rgb": {
              "r": 187,
              "g": 50,
              "b": 12,
              "a": 1
            },
            "hsl": {
              "h": 13.028571428571428,
              "s": 0.8793969849246233,
              "l": 0.3901960784313725,
              "a": 1
            },
            "hsv": {
              "h": 13.028571428571428,
              "s": 0.9358288770053477,
              "v": 0.7333333333333333,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "status",
            "error"
          ]
        },
        "warning": {
          "nob": [
            "system",
            "category",
            "concept",
            "variant"
          ],
          "value": "rgb(252, 199, 79)",
          "filePath": "./src/tokens/status.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant"
            ],
            "value": "{ids.color.yellow.200.value}"
          },
          "name": "IDS_COLOR_STATUS_WARNING",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "status",
            "variant": "warning",
            "hex": "fcc74f",
            "rgb": {
              "r": 252,
              "g": 199,
              "b": 79,
              "a": 1
            },
            "hsl": {
              "h": 41.61849710982659,
              "s": 0.9664804469273744,
              "l": 0.6490196078431373,
              "a": 1
            },
            "hsv": {
              "h": 41.61849710982659,
              "s": 0.6865079365079365,
              "v": 0.9882352941176471,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "status",
            "warning"
          ]
        },
        "success": {
          "nob": [
            "system",
            "category",
            "concept",
            "variant"
          ],
          "value": "rgb(33, 115, 49)",
          "filePath": "./src/tokens/status.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant"
            ],
            "value": "{ids.color.green.100.value}"
          },
          "name": "IDS_COLOR_STATUS_SUCCESS",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "status",
            "variant": "success",
            "hex": "217331",
            "rgb": {
              "r": 33,
              "g": 115,
              "b": 49,
              "a": 1
            },
            "hsl": {
              "h": 131.70731707317074,
              "s": 0.554054054054054,
              "l": 0.2901960784313726,
              "a": 1
            },
            "hsv": {
              "h": 131.70731707317074,
              "s": 0.7130434782608694,
              "v": 0.45098039215686275,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "status",
            "success"
          ]
        }
      },
      "text": {
        "subtle": {
          "nob": [
            "system",
            "category",
            "concept",
            "variant"
          ],
          "value": "rgb(110, 98, 94)",
          "filePath": "./src/tokens/text.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant"
            ],
            "value": "{ids.color.brown.100.value}"
          },
          "name": "IDS_COLOR_TEXT_SUBTLE",
          "attributes": {
            "system": "ids",
            "category": "color",
            "concept": "text",
            "variant": "subtle",
            "hex": "6e625e",
            "rgb": {
              "r": 110,
              "g": 98,
              "b": 94,
              "a": 1
            },
            "hsl": {
              "h": 15,
              "s": 0.0784313725490196,
              "l": 0.4,
              "a": 1
            },
            "hsv": {
              "h": 15,
              "s": 0.14545454545454545,
              "v": 0.43137254901960786,
              "a": 1
            }
          },
          "path": [
            "ids",
            "color",
            "text",
            "subtle"
          ]
        },
        "primary": {
          "on-light": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant",
              "mode"
            ],
            "value": "rgb(51, 30, 17)",
            "filePath": "./src/tokens/text.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "category",
                "concept",
                "variant",
                "mode"
              ],
              "value": "{ids.color.brown.200.value}"
            },
            "name": "IDS_COLOR_TEXT_PRIMARY_ON_LIGHT",
            "attributes": {
              "system": "ids",
              "category": "color",
              "concept": "text",
              "variant": "primary",
              "mode": "on-light",
              "hex": "331e11",
              "rgb": {
                "r": 51,
                "g": 30,
                "b": 17,
                "a": 1
              },
              "hsl": {
                "h": 22.94117647058823,
                "s": 0.5000000000000001,
                "l": 0.13333333333333333,
                "a": 1
              },
              "hsv": {
                "h": 22.94117647058823,
                "s": 0.6666666666666667,
                "v": 0.2,
                "a": 1
              }
            },
            "path": [
              "ids",
              "color",
              "text",
              "primary",
              "on-light"
            ]
          },
          "on-dark": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant",
              "mode"
            ],
            "value": "rgb(250, 249, 247)",
            "filePath": "./src/tokens/text.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "category",
                "concept",
                "variant",
                "mode"
              ],
              "value": "{ids.color.beige.100.value}"
            },
            "name": "IDS_COLOR_TEXT_PRIMARY_ON_DARK",
            "attributes": {
              "system": "ids",
              "category": "color",
              "concept": "text",
              "variant": "primary",
              "mode": "on-dark",
              "hex": "faf9f7",
              "rgb": {
                "r": 250,
                "g": 249,
                "b": 247,
                "a": 1
              },
              "hsl": {
                "h": 40,
                "s": 0.23076923076923025,
                "l": 0.9745098039215686,
                "a": 1
              },
              "hsv": {
                "h": 40,
                "s": 0.011999999999999959,
                "v": 0.9803921568627451,
                "a": 1
              }
            },
            "path": [
              "ids",
              "color",
              "text",
              "primary",
              "on-dark"
            ]
          },
          "normal": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant",
              "mode"
            ],
            "value": "rgb(51, 30, 17)",
            "filePath": "./src/tokens/text.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "category",
                "concept",
                "variant",
                "mode"
              ],
              "value": "{ids.color.brown.200.value}"
            },
            "name": "IDS_COLOR_TEXT_PRIMARY_NORMAL",
            "attributes": {
              "system": "ids",
              "category": "color",
              "concept": "text",
              "variant": "primary",
              "mode": "normal",
              "hex": "331e11",
              "rgb": {
                "r": 51,
                "g": 30,
                "b": 17,
                "a": 1
              },
              "hsl": {
                "h": 22.94117647058823,
                "s": 0.5000000000000001,
                "l": 0.13333333333333333,
                "a": 1
              },
              "hsv": {
                "h": 22.94117647058823,
                "s": 0.6666666666666667,
                "v": 0.2,
                "a": 1
              }
            },
            "path": [
              "ids",
              "color",
              "text",
              "primary",
              "normal"
            ]
          },
          "inverse": {
            "nob": [
              "system",
              "category",
              "concept",
              "variant",
              "mode"
            ],
            "value": "rgb(250, 249, 247)",
            "filePath": "./src/tokens/text.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "category",
                "concept",
                "variant",
                "mode"
              ],
              "value": "{ids.color.beige.100.value}"
            },
            "name": "IDS_COLOR_TEXT_PRIMARY_INVERSE",
            "attributes": {
              "system": "ids",
              "category": "color",
              "concept": "text",
              "variant": "primary",
              "mode": "inverse",
              "hex": "faf9f7",
              "rgb": {
                "r": 250,
                "g": 249,
                "b": 247,
                "a": 1
              },
              "hsl": {
                "h": 40,
                "s": 0.23076923076923025,
                "l": 0.9745098039215686,
                "a": 1
              },
              "hsv": {
                "h": 40,
                "s": 0.011999999999999959,
                "v": 0.9803921568627451,
                "a": 1
              }
            },
            "path": [
              "ids",
              "color",
              "text",
              "primary",
              "inverse"
            ]
          }
        }
      }
    }
  }
};
